<!-- //
组件可视化开发-大屏设计
@auth xuyd
@date 2022-11-27
//-->
<template>
  <div class="screen-design" style="height: calc(100vh); position: relative;">

    <div class="design-layout">
      <div v-show="showSideBar">
        <div id="defineContainer" />
      </div>
      <!-- 分隔条 -->
      <WbSplitBar v-model="showSideBar" position="left"/>
      <!-- 工作台容器 -->
      <div id="workbenchContainer" />
    </div>
    <!-- 右侧属性容器 -->
    <div class="props-container">
      <!-- 分隔条 -->
      <WbSplitBar v-model="showPropsBar" position="right"/>
      <div v-show="showPropsBar">
        <div id="propsContainer" />
      </div>
    </div>
  </div>
</template>

<script>
import {widgetPackage} from '../widget/index.js'; // 组件库
import {widgetMenuList} from '../widget/widgetMenu.js'; // 组件菜单
import * as WidgetUtil from '../utils/util.js';
import DataScreenApi from '@/api/datavisual/dataScreen.api.js';
import {initWorkbench, registerComponents} from "@/views/datavisual/components/workbench/workbench_.js";
import WbSplitBar from "../components/workbench/wb-split-bar.vue";

// 工具栏配置的组件注册{FormXXX:{}, ViewXXX: {}}
const regComponents = WidgetUtil.registerWidget(widgetMenuList, widgetPackage);

export default {
  name: 'ViewScreenDesignMultiInst',
  components: {
    ...regComponents
    ,WbSplitBar
  },
  data() {
    return {
      pageId: null,
      workbench: null,
      widgetTemplateMap: this.$util.listToMap(widgetMenuList, {idField: 'widgetName'}),

      widgetMenuList: [], // 菜单
      widgetViewList: [], // 工作区的所有View组件
      workbenchProps: {// 工作台组件数据
        id: null,
        width: 1920, // 工作台设计宽度
        height: 1080, // 工作台设计高度
        backgroundColor: '#1D202D', // 工作台背景色
      },
    }
  },
  computed: {
    showSideBar: {
      get() {
        return this.$store.getters.showSideBar;
      },
      set(v) {
        this.$store.dispatch('doShowSideBar', v)
      }
    },
    showPropsBar: {
      get() {
        return this.$store.getters.showPropsBar;
      },
      set(v) {
        this.$store.dispatch('doShowPropsBar', v)
      }
    }
  },
  async created() {
    this.pageId = this.$route.query.pageId;
    await this.getWorkbenchProps();
    this.getList();
  },
  mounted() {
    this.workbench = initWorkbench('defineContainer','propsContainer','workbenchContainer')
    registerComponents(this.workbench, regComponents);
    console.log("----scale------->", this.workbench.scale);
  },

  methods: {
    /**
     * 查询工作台信息
     */
    async getWorkbenchProps() {
      await DataScreenApi.getScreenInfo(this.pageId).then(resp => {
        this.workbenchProps = resp.data;
        // console.log('--------getWorkbenchProps--------->', this.workbenchProps)
      })
    },

    /**
     * 查询页面组件数据
     */
    getList() {
      DataScreenApi.selectWidgetList(this.pageId).then(resp => {
        let dataList = WidgetUtil.api2Vnode(this.widgetTemplateMap, resp.data)
        this.widgetViewList.push(...dataList);
        // console.log('--------加载db数据--------->', data, this.widgetViewList)
      })
    },

    /**
     * 拖动结束，设置根据x,y坐标放置
     */
    handleAddWidget(widget) {
      return new Promise((resolve, reject) => {
        DataScreenApi.addWidget(widget).then(resp => {
          resolve(resp.data);
        });
      })
    },

    handleSave() {
      DataScreenApi.saveScreen(this.workbenchProps);
      DataScreenApi.updateWidgetList(this.widgetViewList).then(resp => {
        this.$modal.msgSuccess("保存成功");
      });
    },

    handlePreview() {
      let routeData = this.$router.resolve({name: 'ViewScreenPreview'});
      window.open(routeData.href + '?pageId=' + this.pageId, '_blank');
    },
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/variables.less';

.design-layout {
  width: 100%;
  min-width: 1200px;
  height: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  background-color: @dv_background_bg;
}
</style>
